var grayscale = {
  gray900: '#212529',
  gray800: '#495057',
  gray700: '#868E96',
  gray600: '#ADB5BD',
  gray500: '#CED4DA',
  gray400: '#DEE2E6',
  gray300: '#E9ECEF',
  gray200: '#F1F3F5',
  gray100: '#F8F9FA',
  gray9: '#212529',
  gray8: '#495057',
  gray7: '#868E96',
  gray6: '#ADB5BD',
  gray5: '#CED4DA',
  gray4: '#DEE2E6',
  gray3: '#E9ECEF',
  gray2: '#F1F3F5',
  gray1: '#F8F9FA'
};
var orange = {
  pendingDark: '#773400',
  orange900: '#773400',
  pendingActive: '#B35C00',
  orange700: '#B35C00',
  pendingHover: '#D67700',
  orange600: '#D67700',
  pending: '#F99500',
  orange500: '#F99500',
  pendingLight: '#FEEACC',
  orange50: '#FEEACC'
};
var blue = {
  infoDark: '#002A5C',
  blue900: '#002A5C',
  infoActive: '#004F89',
  blue700: '#004F89',
  links: '#0067A0',
  infoHover: '#0067A0',
  blue600: '#0067A0',
  info: '#319AC5',
  blue500: '#319AC5',
  infoLight: '#E0F0F6',
  blue50: '#E0F0F6'
};
var yellow = {
  warningDark: '#7A460C',
  yellow900: '#7A460C',
  warningActive: '#B77B21',
  yellow700: '#B77B21',
  warningHover: '#DB9C30',
  yellow600: '#DB9C30',
  warning: '#FEC149',
  yellow500: '#FEC149',
  warningLight: '#FFF3DB',
  yellow50: '#FFF3DB'
};
var red = {
  red50: '#FADADB',
  red500: '#E4464A',
  red600: '#C43343',
  red700: '#A4233D',
  red900: '#6D0D31',
  dangerDark: '#6D0D31',
  dangerActive: '#A4233D',
  dangerHover: '#C43343',
  danger: '#E4464A',
  dangerLight: '#FADADB'
};
var green = {
  green50: '#DAE7C9',
  green100: '#D0E3B4',
  green200: '#BDD894',
  green500: '#63A105',
  green600: '#468502',
  green700: '#3D7302',
  green900: '#224D00',
  primaryDark: '#224D00',
  primaryActive: '#3D7302',
  primaryHover: '#4F8A03',
  primary: '#63A105',
  primaryLight: '#E8F1D9'
};
export { grayscale, orange, blue, yellow, red, green };